import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-top: 6px;
  font-size: 0.9rem;
  color: #555;
`;

const Summary = styled.div`
  word-break: break-word;
`;

const Toggle = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  margin-top: 4px;
  color: #2d3a80;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    opacity: 0.8;
  }
`;

const Full = styled.pre`
  margin: 0;
  padding: 10px 12px;
  max-height: 200px;
  overflow: auto;
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
  color: #444;
`;

const PREVIEW_LENGTH = 160;

const ErrorDetails: React.FC<{ message?: string | null }> = ({ message }) => {
  const [expanded, setExpanded] = useState(false);
  const trimmed = typeof message === 'string' ? message.trim() : '';

  if (!trimmed) return null;

  const needsTruncation = trimmed.length > PREVIEW_LENGTH;

  if (!needsTruncation) {
    return <Container><Summary>{trimmed}</Summary></Container>;
  }

  const sentenceEnd = trimmed.indexOf('. ');
  const cutAt = sentenceEnd > 0 && sentenceEnd < PREVIEW_LENGTH ? sentenceEnd + 1 : PREVIEW_LENGTH;
  const preview = trimmed.slice(0, cutAt).trimEnd() + '…';

  return (
    <Container>
      {expanded ? <Full>{trimmed}</Full> : <Summary>{preview}</Summary>}
      <Toggle
        type="button"
        aria-expanded={expanded}
        onClick={() => setExpanded((v) => !v)}
      >
        {expanded ? 'Hide details' : 'Show details'}
      </Toggle>
    </Container>
  );
};

export default ErrorDetails;
